var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.87,
    d: "M6 15.5c.825 0 1.5-.675 1.5-1.5h-3c0 .825.675 1.5 1.5 1.5m4.5-4.5V7.25c0-2.302-1.223-4.23-3.375-4.74V2C7.125 1.378 6.622.875 6 .875S4.875 1.377 4.875 2v.51C2.73 3.02 1.5 4.94 1.5 7.25V11L0 12.5v.75h12v-.75zm-1.5.75H3v-4.5c0-1.86 1.133-3.375 3-3.375S9 5.39 9 7.25z"
  })));
};
export default SvgNotification;